// extracted by mini-css-extract-plugin
export var infoRow = "_rr-2";
export var labelContainer = "_rr-0";
export var rightInfo = "_rr-1";